export enum PeriodicReviewStatus {
  UpcomingReview = 0,
  UnderReview = 1,
  ReviewOverdue = 2,
  ReviewCompleted = 3,
  ReviewArchived = 4,
}

export const PeriodicReviewStatusKeys = {
  [PeriodicReviewStatus.UpcomingReview]: 'common:periodic-review-status.upcoming',
  [PeriodicReviewStatus.UnderReview]: 'common:periodic-review-status.under-review',
  [PeriodicReviewStatus.ReviewOverdue]: 'common:periodic-review-status.overdue',
  [PeriodicReviewStatus.ReviewCompleted]: 'common:periodic-review-status.completed',
  [PeriodicReviewStatus.ReviewArchived]: 'common:list.filter.archived',
} as const;

export const PlatformPeriodicReviewStatusToGQLStatus: Record<PeriodicReviewStatus, string> = {
  [PeriodicReviewStatus.UpcomingReview]: 'UPCOMING_REVIEW',
  [PeriodicReviewStatus.UnderReview]: 'UNDER_REVIEW',
  [PeriodicReviewStatus.ReviewOverdue]: 'REVIEW_OVERDUE',
  [PeriodicReviewStatus.ReviewCompleted]: 'REVIEW_COMPLETED',
  [PeriodicReviewStatus.ReviewArchived]: 'REVIEW_ARCHIVED',
};

export const GQLPeriodicReviewStatusToPlatformStatus: Record<string, PeriodicReviewStatus> = Object.fromEntries(
  Object.entries(PlatformPeriodicReviewStatusToGQLStatus).map(([key, value]) => [value, Number(key) as PeriodicReviewStatus]),
);
